import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useIntercom } from 'react-use-intercom';
import { useAppSelector } from 'redux/hooks';
import { openActions } from 'services/open-actions/openActions';

const OPEN_PARAM = 'open';

const useOpenParamDispatcher = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const intercom = useIntercom();
    const intercomInitialised = useAppSelector((state) => state.intercom.initialised);
    const firedRef = useRef(false);

    useEffect(() => {
        if (firedRef.current) return;
        if (!intercomInitialised) return;

        const actionName = searchParams.get(OPEN_PARAM);
        if (!actionName) return;

        firedRef.current = true;

        const action = openActions[actionName];
        if (!action) {
            console.warn(`[useOpenParamDispatcher] Unknown ?open=${actionName}`);
            return;
        }

        action({ params: searchParams, navigate, intercom });

        const next = new URLSearchParams(searchParams);
        next.delete(OPEN_PARAM);
        setSearchParams(next, { replace: true });
    }, [searchParams, setSearchParams, navigate, intercom, intercomInitialised]);
};

export default useOpenParamDispatcher;
